export const FREIGHT_NAME = "Frakt";
export const PRODUCT_BUNDLE_FORMATS = {
    PHYSICAL: "Samling - Fysisk",
    DIGITAL: "Samling - Digitalt",
    COMBINATION: "Samling - Kombinert (Digitalt + Fysisk)",
};
